import cx from 'classnames';
import useTranslation from 'next-translate/useTranslation';

import { TsearchCategoryName } from '../../../../../utils/get-category-names';
import Trustpilot from '../../../../modules/trustpilot';
import Breadcrumbs from '../../../../modules/v2/breadcrumbs';
import ValueProposition from '../../../../modules/value-proposition';
import { useBreadcrumbsType } from '../../../vehicle/hooks/use-breadcrumbs';
import LastEntries from '../last-entries';
import LastVehicles from '../last-vehicles';

import VersionSchema from './seo';
import VersionsList from './version-list';
import VersionsTitle from './versions-title';
import AlertForm from '../../../../modules/v2/create-part-alert/form';
import PageTitle from '../../../../ui/typography/page-title';
import BrandHistory from '../../../../modules/v2/brand-history';
import { getBrandHistory } from '../../../../../services/brand-history';
import { useRouter } from 'next/router';
import SEOContent from './seo-content-section';

type ModelsPageType = {
  breadcrumbs: ReturnType<useBreadcrumbsType>;
  info: TsearchCategoryName | null;
  selection: { category: TCategorySelection };
  vehicle: TCarInfo;
  groups: TCategories;
  stock: any;
  versions: TResultAPICarsBySlug;
  lastEntries: TProductListItem[];
  vehicles: TVehicleCard[];
  translatedSlugs: any;
};

const VersionsPage = ({
  breadcrumbs,
  info,
  selection,
  vehicle,
  groups,
  stock,
  versions,
  lastEntries,
  vehicles,
  translatedSlugs,
}: ModelsPageType) => {
  const { t } = useTranslation();
  const { locale = 'en' } = useRouter();
  const brandHistory = getBrandHistory({
    locale: locale,
    slug: vehicle.brand.alias,
  });

  return (
    <>
      <VersionSchema
        breadcrumbs={breadcrumbs}
        info={info}
        selection={selection}
        vehicle={vehicle}
        translatedSlugs={translatedSlugs}
        stock={stock}
      />
      <Breadcrumbs
        items={breadcrumbs}
        currentPage={vehicle?.model?.name ?? vehicle.brand.name}
      />
      <VersionsTitle
        groups={groups}
        selection={selection}
        vehicle={vehicle}
        info={info}
        stock={stock}
      />
      <VersionsList
        vehicle={vehicle}
        versions={versions}
        stock={stock && stock[0].stock > 0}
      />
      {lastEntries && !!lastEntries.length && (
        <LastEntries products={lastEntries} vehicle={vehicle} />
      )}
      <ValueProposition
        infoToDisplayInTitle={`${vehicle?.brand.name} ${vehicle?.model?.name}`}
      />
      {vehicles && !!vehicles.length && (
        <LastVehicles products={vehicles} vehicle={vehicle} />
      )}
      <section className="w-full bg-blue-10 py-12 lg:py-16 text-justify ">
        {brandHistory && (
          <BrandHistory
            imageURL={vehicle.brand.logo_url}
            {...brandHistory}
            brand={vehicle.brand.name}
            vehicle={vehicle}
            stock={stock && stock[1]?.stock.toLocaleString(locale)}
          />
        )}
        <SEOContent
          withPart={!!selection?.category}
          selection={selection}
          stock={stock && stock[1]?.stock.toLocaleString(locale)}
          info={info}
          vehicle={vehicle}
        ></SEOContent>
      </section>
      <div className="bg-white">
        <Trustpilot className={'py-8 lg:py-6'} backgroundColor="bg-white" />
      </div>
    </>
  );
};

export default VersionsPage;
